import { useEffect } from "react";
import { sendError } from "easy-analytics/client";
import { setServerUrl, getUseAPIFrontend, getAPIFrontend, setHeaders } from "typed-client-server-api/hooks";

import { API } from "../../types";

setServerUrl(process.env.NODE_ENV === "development" ? "http://localhost:1111" : "");

let authorization = "";

setHeaders(() => ({
    "Content-Type": "application/json",
    "Authorization": authorization,
}));

export function setAuthorizationHeader(newAuthorization: string) {
    authorization = newAuthorization;
}

export const api = getAPIFrontend<API>();
export const useApi = getUseAPIFrontend<API>();

export function handleError(error?: null | string | Error, errorInfo?: any) {
    if (!error) return;
    if (typeof error === "string") error = new Error(error);

    if (errorInfo && typeof errorInfo === "object" && typeof errorInfo.componentStack === "string") {
        error.stack = errorInfo.componentStack;
    }

    console.error(error);
    sendError(error);
}

export function useHandleError(error?: null | string | Error) {
    useEffect(() => {
        handleError(error);
    }, [error]);
}
